import { getApi, postApi } from '../../services/api_methods';

export const signInUrl = (data) => postApi(`/auth/login`, data);

export const logoutUrl = (data) => postApi(`/auth/logout-device`, data);

export const dropDownUrl = () => getApi(`/admin/get-master-data`);

export const getMyDevices = () => getApi(`/auth/get-my-devices`);

export const deleteDeviceApi = (data) => postApi(`/auth/delete-device`, data);
